import { render, staticRenderFns } from "./SearchSuggestion.vue?vue&type=template&id=468be68c&scoped=true&"
import script from "./SearchSuggestion.vue?vue&type=script&lang=js&"
export * from "./SearchSuggestion.vue?vue&type=script&lang=js&"
import style0 from "./SearchSuggestion.vue?vue&type=style&index=0&id=468be68c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "468be68c",
  null
  
)

export default component.exports